$(document).ready(function () {
	var
		ua = navigator.userAgent.toLowerCase(),
		event = (ua.match(/Android/i) || ua.match(/iPad/i) || ua.match(/iPod/i) || ua.match(/iPhone/i)) ? "touchstart" : "click",
		isMobile = ua.match(/(iphone|ipod|ipad|android)/),
		window_w = $(window).width(),
		window_h = $(window).height(),
		is_home = $('body').hasClass('ishome');

	$.blockUI.defaults.message = 'Aguarde.';

	 /* $.cookieBar({
		message: 'Este site utiliza cookies que permitem melhorar o desempenho e experiência do utilizador na utilização do mesmo. Para mais informação, consulte a nossa {policy_url}',
		acceptText: 'OK',
		fixed: true,
		bottom: true,
		policyButton: true,
		policyText: 'Política de Cookies',
		policyURL: 'https://www.turmaimbativel.pt/politica-cookies/',
	});  */

	$('html').removeClass('no-js');

	if (("standalone" in window.navigator) && window.navigator.standalone) {
		$('html').addClass('ios-standalone');
	}

	if ($.browser.msie) {
		$('html').addClass('is-ie');
		$('html').addClass('ie-' + $.browser.versionNumber);
	}

	if ($.browser.msedge) {
		$('html').addClass('is-edge');
	}

	if ($.browser.iphone && $.browser.safari) {
		$('html').addClass('ios-safari');
	}

	if ($.browser.iphone && $.browser.chrome) {
		$('html').addClass('ios-chrome');
	}

	if ($.browser.android && $.browser.chrome) {
		$('html').addClass('android-chrome');
	}


	if ($('.mh').length) {
		$('.mh').matchHeight(true);
	}
	if ($('.mh1').length) {
		$('.mh1').matchHeight(true);
	}

	$('#scroll-down-home a').click(function () {
		$('body,html').animate({ scrollTop: $(window).height() }, 800);
		return false;
	});

	$('#scroll-down-page a').click(function () {
		$('body,html').animate({ scrollTop: $(".page-header-container").height() }, 800);
		return false;
	});

	var swiper1 = new Swiper(".single-slider", {
		effect: "fade",
		allowTouchMove: false,
		pagination: {
			el: ".single-swiper-pagination",
			clickable: true,
		},
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
	});

	/**
	 * Embed responsive
	 */
	var iframe = $('.text iframe');
	if (iframe.length) {
		iframe.wrap("<div class='embed'></div>");
	}


	$('body').on('click', '.toggle:not(.close)', function (e) {
		e.preventDefault();
		blockScroll(1);
		$('.menu-mobile').addClass('show');
		$(this).addClass('close');
	});

	$('body').on('click', '.toggle.close', function (e) {
		e.preventDefault();
		if ($('#menu-principal').hasClass('show')) {
			$('.toggle').removeClass('back');
			$('#menu-principal').removeClass('show');
			$('.sub-menu').removeClass('show');
		} else {
			blockScroll(0);
			$('.menu-mobile').removeClass('show');
			$(this).removeClass('close');
		}
	});

	function blockScroll(block) {
		if (block == 1) {
			$('html').addClass('block-scroll');
		} else if (block == 0) {
			$('html').removeClass('block-scroll');
		}
	}

	$(window).on('scroll', function () {


		if (!$('header').hasClass("no-scrolled")) {
			if ($(window).scrollTop() > 45)
				$('header').addClass("scrolled")
			else
				$('header').removeClass("scrolled")
		}

	});
	$(window).trigger("scroll");

	$('#menu-toggler').on('click', function () {
		var el = $(this);
		if (el.hasClass('opened')) {
			el.removeClass('opened');
			$('#site-navigation').removeClass('show');
			blockScroll(0);
		} else {
			el.addClass('opened');
			$('#site-navigation').addClass('show');
			blockScroll(1);
		}
	});

	var swiper = new Swiper(".whatsnew-slider", {
		slidesPerView: 5,
		spaceBetween: 20,
		centeredSlides: true,
		navigation: {
			nextEl: ".swiper-button-next" + " top",
			prevEl: ".swiper-button-prev" + " top",
		},
		on:
		{
			init: function () {
				var obj = $('.swiper-wrapper');
				var transformMatrix = obj.css("-webkit-transform") ||
					obj.css("-moz-transform") ||
					obj.css("-ms-transform") ||
					obj.css("-o-transform") ||
					obj.css("transform");
				var matrix = transformMatrix.replace(/[^0-9\-.,]/g, '').split(',');
				var x = matrix[12] || matrix[4];//translate x
				console.log(x)
				$(".whatsnew-pagination").css("left", parseInt(x) + "px");
			},
			reachEnd: function () {
				$(".whatsnew-overlay-content a.next").addClass("disabled");
				$(".whatsnew-overlay-content a.prev").removeClass("disabled");
			},
			reachBeginning: function () {
				$(".whatsnew-overlay-content a.prev").addClass("disabled");
				$(".whatsnew-overlay-content a.next").removeClass("disabled");
			},
		},
		breakpoints: {
			1400: {
				slidesPerView: 5,
			},
			992: {
				slidesPerView: 4,
			},
			700: {
				slidesPerView: 3,
			},
			414: {
				slidesPerView: 2,
			},
			150: {
				slidesPerView: 1,
			},
		},
	});

	$(".whatsnew-overlay-content a.prev").click(function (e) {
		e.preventDefault();
		$('.swiper-slide-active').prev().removeClass("opaque");
		$(".whatsnew-overlay-content a.next").removeClass("disabled");
		swiper.slidePrev();
	});

	$(".whatsnew-overlay-content a.next").click(function (e) {
		e.preventDefault();
		$('.swiper-slide-active').addClass("opaque");
		$(".whatsnew-overlay-content a.prev").removeClass("disabled");
		swiper.slideNext();
	});


	var swiper1 = new Swiper(".turma-slider", {
		//effect: "fade",
		slidesPerView: 1,
		spaceBetween: 30,
		autoHeight: true,
		pagination: {
			el: ".single-swiper-pagination-turma",
			clickable: true,
		},
		navigation: {
			nextEl: ".swiper-button-next.tur",
			prevEl: ".swiper-button-prev.tur",
		},
	});

	var swiper2 = new Swiper(".partners-list-slider", {
		//effect: "fade",
		slidesPerView: "auto",
		navigation: {
			nextEl: ".swiper-button-next.fam",
			prevEl: ".swiper-button-prev.fam",
		},
	});

	var swiper = new Swiper(".swiper.familia", {
		slidesPerView: 3,
		spaceBetween: 30,
		slidesPerGroup: 1,
		loop: $('.familia-slide').length > 3 ? true : false,
		loopedSlides: 8,
		//loop: true,
		centeredSlides: true,
		pagination: {
			//   el: ".swiper-pagination",
			//   clickable: true,
		},
		navigation: {
			//   nextEl: ".swiper-button-next-familia",
			//   prevEl: ".swiper-button-prev-familia",
		},
		on: {
		},
		breakpoints: {
			0: {
				slidesPerView: 1,
				spaceBetween: 0,
			},
			451: {
				slidesPerView: 3,
				spaceBetween: 10,
			},
			768: {
				slidesPerView: 3.8,
			},
			1024: {
				slidesPerView: 3.8,
			}
		}

	});
	//   swiper.on('afterInit', function () {

	var swiper1 = new Swiper(".datas-slider", {
		//effect: "fade",
		slidesPerView: 1,
		autoHeight: true,
		pagination: false,
		navigation: {
			nextEl: ".swiper-button-next.data",
			prevEl: ".swiper-button-prev.data",
		},
	});

	var getInitialSlide = $(".datas-slider-1").data("initialslide");
	if (getInitialSlide === undefined || getInitialSlide === null){
		var idSlide = 0;
	} else {
		var idSlide = getInitialSlide;
	}

	var swiper2 = new Swiper(".datas-slider-1", {
		//effect: "fade",
		initialSlide: idSlide,
		slidesPerView: 1,
		autoHeight: true,
		pagination: false,
		navigation: {
			nextEl: ".swiper-button-next.data.type-2",
			prevEl: ".swiper-button-prev.data.type-2",
		},
	});
	
	//   });
	//   swiper.on('slideChangeTransitionEnd', function () {
	// 	$(".familia .swiper-slide").removeClass("active");
	// 	$(".familia .swiper-slide.swiper-slide-active").addClass("active");
	// 	$(".familia .swiper-slide.swiper-slide-active").next().addClass("active");
	// 	$(".familia .swiper-slide.swiper-slide-active").next().next().addClass("active");

	//   });
	/**
	 * Trigger AOS
	 */
	setTimeout(function () {
		/*$('#loader').fadeOut(500, function () {
			$(this).remove();
		});*/
		$('.loading-container').fadeOut();
		AOS.init({
			'offset': -50,
			disable: 'mobile'
		});
	}, 300);

	/**
	 * Fade loading images
	 */
	var load_images_bg = $('body').find('.load-img:not(.loaded), .load-img-uncover:not(.loaded)');
	if (load_images_bg.length) {
		load_images_bg.each(function (index, element) {
			var image = new Image(),
				$element = $(element),
				is_bg_or_img = typeof $element.data('src') !== 'undefined';

			image.onload = function () {
				if (is_bg_or_img) {
					$element.css("backgroundImage", "url('" + $element.attr("data-src") + "')").removeAttr('data-src');
				}
				setTimeout(function () {
					$element.parent().removeClass('loading');
					$element.addClass('loaded');
				}, 200);
			};
			image.src = is_bg_or_img ? $element.attr("data-src") : $element.find('img').attr('src');
		});
	}

	/**
	 * Lazy load images
	 */
	var velcroLazy = {
		/**
		 * init
		 * correr on load e sempre que for necessário, por exemplo, a seguir a uma call ajax
		 * elements: passar class dos ementos a fazer lazy load (ex: .lazy)
		 * ex: velcroLazy.init('.lazy');
		 */
		init: (elements) => {
			let lazyImages = $(elements);

			if ("IntersectionObserver" in window) {
				var lazyImageObserver = new IntersectionObserver(function (entries, observer) {
					entries.forEach(function (entry) {
						if (entry.isIntersecting) {
							var lazyImage = $(entry.target),
								image = lazyImage.find('img')[0] || new Image(),
								is_bg_or_img = typeof lazyImage.data('src') !== 'undefined';

							image.onload = function () {
								if (is_bg_or_img) {//is bg
									lazyImage.css("backgroundImage", "url('" + lazyImage.data("src") + "')").removeAttr('data-src');
								}
								setTimeout(function () {
									lazyImage.addClass('loaded').removeClass("lazy").parent().removeClass('loading');
								}, 200);
							};

							image.src = is_bg_or_img ? lazyImage.data("src") : lazyImage.find('img').attr('data-src');
							lazyImageObserver.unobserve(entry.target);
						}
					});
				});

				lazyImages.each(function () {
					lazyImageObserver.observe(this);
				});
			} else {
				lazyImages.each(function () {
					var is_bg_or_img = typeof $(this).data('src') !== 'undefined';
					if (is_bg_or_img) {//is bg
						$(this).css("backgroundImage", "url('" + $(this).data("src") + "')").removeAttr('data-src');
					} else {//is img
						$(this).find('img').attr("src", $(this).find('img').data("src")).removeAttr('data-src');
					}
					$(this).addClass('loaded').removeClass("lazy").parent().removeClass('loading');
				});
			}
		}
	}

	velcroLazy.init('.lazy');

	var root = $('html,body');
	function smoothScrollingTo(target) {

		var target = $(target);
		if (target.length) {
			root.animate({
				scrollTop: target.offset().top - 100
			}, 400, "swing");
		}
	}

	$('a[href*=\\#]:not([href=\\#],[data-toggle],.open-popup)').on('click', function (event) {
		smoothScrollingTo(this.hash);
		if ($('.menu-mobile').hasClass('show')) {
			toogleMenu();
		}
	});

	smoothScrollingTo(location.hash);


	if (!Modernizr.objectfit) {
		$('body .objectfit').each(function () {
			var $container = $(this),
				imgUrl = $container.find('img').prop('src');
			if (imgUrl) {
				$container
					.css('backgroundImage', 'url(' + imgUrl + ')')
					.addClass('compat-object-fit');
			}
		});
	}


	/**
	 * Scroll do menu
	 */
	windowOnScroll();
	$(window).on('scroll', function () {
		windowOnScroll();
	});

	let turmaDefaultInputs = $('.turmas-form-container');
	$('.add-turma').on('click', function () {
		turmaDefaultInputs.clone().find("input:text").val("").end().append('<span class="delete-turma">X</span>').appendTo('#turmas-form-outer');
	});

	$('#inscrever-form').on('click', '.delete-turma', function (e) {
		$(this).parent().remove();
	});

	$('.toggle-form').on('click', function () {
		$('#form-section').toggleClass('show');
		isScrollBlock = 1 - isScrollBlock;
		blockScroll(isScrollBlock);
	});

	if ($('.input-file').length) {

		var input = $('.files'),
			caption = $('.loaded-files');

		input.on('change', function () {
			var fileName = '';
			if ($(this)[0].files && $(this)[0].files.length > 1) {
				for (var i = 0; i < $(this)[0].files.length; i++) {
					const file = $(this)[0].files[i];
					fileName += file.name + '<br>';
				}
			} else {
				fileName = $(this).val().split('\\').pop();
			}


			if (fileName)
				caption.html(fileName).show();
			else
				caption.html('').hide();
		});
	}

	let currentArtigosPage = 1;
	$('.ver-mais-artigos-btn').on('click', function () {
		currentArtigosPage++; // Do currentPage + 1, because we want to load the next page
		var $this = $(this);
		$this.attr('disabled',true).text('A carregar...');
		$.ajax({
			type: 'POST',
			url: main_script.ajaxurl,
			dataType: 'html',
			data: {
				action: 'artigos_load_more',
				paged: currentArtigosPage,
			},
			success: function (res) {
				$('.banner-list').append(res);
				velcroLazy.init('.lazy');
				$this.attr('disabled',false).text('Ver Mais');
				if($this.data('max') <= $('.banner-list .banner').length){
					$this.remove();
				}
			}
		});
	});

	let currentEpisodePage = 1;
	$('.ver-mais-episodios-btn').on('click', function () {
		currentEpisodePage++; // Do currentPage + 1, because we want to load the next page
		var $this = $(this);
		$this.attr('disabled',true).text('A carregar...');
		$.ajax({
			type: 'POST',
			url: main_script.ajaxurl,
			dataType: 'html',
			data: {
				action: 'episodios_load_more',
				paged: currentEpisodePage,
			},
			success: function (res) {
				$('.episodios-inner').append(res);
				velcroLazy.init('.lazy');
				$this.attr('disabled',false).text('Ver Mais');
				if($this.data('max') <= $('.episodios-inner .episodio-wrap').length){
					$this.remove();
				}
			}
		});
	});

});

/**
 * Block scroll
 * @param block
 */
function blockScroll(block) {
	if (block == 1) {
		$('html').addClass('block-scroll');
	} else if (block == 0) {
		$('html').removeClass('block-scroll');
	}
}

/**
 * Verificar se é um email válido
 */
function IsEmail(email) {
	var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(email) ? true : false;
}

/**
 * Verifica se a checkbox de política de privacidade está ou não seleccionada
 */
function checkPolicy(form) {
	var checked = form.find('input[name="checkpolicy[]"]:checked').length;
	if (checked === 1) {
		return true;
	}

	return false;
}

/**
 * Window on scroll
 */
function windowOnScroll() {
	if ($(window).scrollTop() > 35 && $('.site-header').hasClass('big') && $('.site-header').hasClass('should-big')) {
		$('.site-header').removeClass('big');
	} else if ($(window).scrollTop() <= 35 && !$('.site-header').hasClass('big') && $('.site-header').hasClass('should-big')) {
		$('.site-header').addClass('big');
	}
}


if ($('#inscrever-form').length) {
	var appRegister = new Vue({
		el: "#inscrever-form",
		canSubmit: false,
		data: {
			feedback: {
				message: '',
				class: ''
			}
		},
		methods: {

			showAlert: function () {
				$('#alert').addClass('show');
				blockScroll(1);
			},

			closeAlert: function () {
				$('#alert').removeClass('show');
				blockScroll(0);
			},

			confirmSubmit: function () {
				this.canSubmit = true;
				this.closeAlert();
				this.submitFormInscrever();
			},

			/**
			 * Submeter
			 */
			submitFormInscrever: function () {
				var $this = this;

				if (!$this.canSubmit) {
					$this.showAlert();
					return false;
				}

				grecaptcha.ready(function () {
					grecaptcha.execute('6LdyBFQiAAAAACiLItMIJLYdPy2P-HiD3jKmPHt-', { action: 'login' }).then(function (token) {

						var form = $('form.inscrever-form');
						var fields = form.serialize();
						$this.feedback.message = '';

						$.blockUI({
							message: '<h5>Aguarde</h5>'
						});

						fields += '&action=register_ajax';
						fields += '&token=' + token;

						$.ajax({
							url: main_script.ajaxurl,
							type: 'POST',
							data: fields,
							dataType: 'json',
							success: function (r) {
								if (r.success) {
									form[0].reset();
								}
								$this.feedback.message = r.data;
								$this.feedback.class = r.success ? 'ok' : 'error';
								$.unblockUI();
							},
							error: function (r) {
								console.log(r);
								$this.feedback.message = 'Ocorreu um erro';
								$this.feedback.class = 'error';
								$.unblockUI();
							}
						});

					});
				});
			}
		}
	});
}


if ($('#login-form').length) {
	var appLogin = new Vue({
		el: "#login-form",
		data: {
			feedbackLogin: {
				message: '',
				class: ''
			}
		},
		methods: {

			/**
			 * Submeter
			 */
			submitFormLogin: function () {
				var $this = this;

				grecaptcha.ready(function () {
					grecaptcha.execute('6LdyBFQiAAAAACiLItMIJLYdPy2P-HiD3jKmPHt-', { action: 'login' }).then(function (token) {

						var form = $('#login-form');
						var fields = form.serialize();
						$this.feedbackLogin.message = '';

						$.blockUI({
							message: '<h5>Aguarde</h5>'
						});

						fields += '&action=login_ajax';
						fields += '&token=' + token;

						$.ajax({
							url: main_script.ajaxurl,
							type: 'POST',
							data: fields,
							dataType: 'json',
							success: function (r) {
								if (r.success) {
									form[0].reset();
									setTimeout(() => {
										window.location.reload();
									}, 1000);
								}
								$this.feedbackLogin.message = r.data;
								$this.feedbackLogin.class = r.success ? 'ok' : 'error';
								$.unblockUI();
							},
							error: function (r) {
								$this.feedbackLogin.message = 'Ocorreu um erro';
								$this.feedbackLogin.class = 'error';
								$.unblockUI();
							}
						});

					});
				});
			}
		}
	});
}

if ($('#reset-password-form').length) {
	var appLogin = new Vue({
		el: "#reset-password-form",
		data: {
			feedbackLogin: {
				message: '',
				class: ''
			}
		},
		methods: {

			/**
			 * Submeter
			 */
			submitFormReset: function () {
				var $this = this;

				grecaptcha.ready(function () {
					grecaptcha.execute('6LdyBFQiAAAAACiLItMIJLYdPy2P-HiD3jKmPHt-', { action: 'reset' }).then(function (token) {

						var form = $('#reset-password-form');
						var fields = form.serialize();
						$this.feedbackLogin.message = '';

						$.blockUI({
							message: '<h5>Aguarde</h5>'
						});

						fields += '&action=reset_password_ajax';
						fields += '&token=' + token;

						$.ajax({
							url: main_script.ajaxurl,
							type: 'POST',
							data: fields,
							dataType: 'json',
							success: function (r) {
								if (r.success) {
									form[0].reset();
								}
								$this.feedbackLogin.message = r.data;
								$this.feedbackLogin.class = r.success ? 'ok' : 'error';
								$.unblockUI();
							},
							error: function (r) {
								$this.feedbackLogin.message = 'Ocorreu um erro';
								$this.feedbackLogin.class = 'error';
								$.unblockUI();
							}
						});

					});
				});
			}
		}
	});
}


if ($('#form-concurso').length) {
	var appRegister = new Vue({
		el: "#form-concurso",
		canSubmit: false,
		data: {
			feedback: {
				message: '',
				class: ''
			}
		},
		methods: {

			showAlert: function () {
				$('#alert').addClass('show');
				blockScroll(1);
			},

			closeAlert: function () {
				$('#alert').removeClass('show');
				blockScroll(0);
			},

			confirmSubmit: function () {
				this.canSubmit = true;
				this.closeAlert();
				this.submitFormConcurso();
			},

			/**
			 * Submeter
			 */
			submitFormConcurso: function () {
				var $this = this;

				if (!$this.canSubmit) {
					$this.showAlert();
					return false;
				}

				grecaptcha.ready(function () {
					grecaptcha.execute('6LdyBFQiAAAAACiLItMIJLYdPy2P-HiD3jKmPHt-', { action: 'login' }).then(function (token) {

						var form = $('form.form-concurso');
						var fd = new FormData();
						var files_data = $('.files');

						$.each($(files_data), function (i, obj) {
							$.each(obj.files, function (j, file) {
								fd.append('files[' + j + ']', file);
							})
						});

						$this.feedback.message = '';

						$.blockUI({
							message: '<h5>Aguarde</h5>'
						});

						fd.append('action', 'concurso_ajax');
						fd.append('tema_chave', $('select option:selected').val());
						fd.append('agrupamento', $('input[name="agrupamento"]').val());
						fd.append('turma', $('input[name="turma"]').val());
						fd.append('ano_escolar', $('input[name="ano_escolar"]').val());
						fd.append('ideia', $('input[name="ideia"]').val());
						fd.append('descricao', $('textarea[name="descricao"]').val());
						fd.append('info', $('textarea[name="info"]').val());
						fd.append('concurso_nonce', $('input[name="concurso_nonce"]').val());
						if ($('#checkpolicy').is(':checked')) {
							fd.append('checkpolicy', 1);
						}
						fd.append('token', token);

						console.log($('#checkpolicy').is(':checked'));

						$.ajax({
							url: main_script.ajaxurl,
							type: 'POST',
							data: fd,
							contentType: false,
							processData: false,
							dataType: 'json',
							success: function (r) {
								if (r.success) {
									form[0].reset();
								}
								$this.feedback.message = r.data;
								$this.feedback.class = r.success ? 'ok' : 'error';
								$.unblockUI();
							},
							error: function (r) {
								$this.feedback.message = 'Ocorreu um erro';
								$this.feedback.class = 'error';
								$.unblockUI();
							}
						});

					});
				});
			}
		}
	});
}
if ($('#form-contactos').length) {
	var appLogin = new Vue({
		el: "#form-contactos",
		canSubmit: false,
		data: {
			feedback: {
				message: '',
				class: ''
			}
		},
		methods: {

			showAlert: function () {
				$('#alert').addClass('show');
				blockScroll(1);
			},

			closeAlert: function () {
				$('#alert').removeClass('show');
				blockScroll(0);
			},

			confirmSubmit: function () {
				this.canSubmit = true;
				this.closeAlert();
				this.submitFormContacto();
			},

			/**
			 * Submeter
			 */
			submitFormContacto: function () {
				var $this = this;

				if (!$this.canSubmit) {
					$this.showAlert();
					return false;
				}

				grecaptcha.ready(function () {
					grecaptcha.execute('6LdyBFQiAAAAACiLItMIJLYdPy2P-HiD3jKmPHt-', { action: 'login' }).then(function (token) {

						var form = $('.contactos-form');
						var fields = form.serialize();
						$this.feedback.message = '';

						$.blockUI({
							message: '<h5>Aguarde</h5>'
						});

						fields += '&action=contactos_ajax';
						fields += '&token=' + token;

						$.ajax({
							url: main_script.ajaxurl,
							type: 'POST',
							data: fields,
							dataType: 'json',
							success: function (r) {
								if (r.success) {
									form[0].reset();
								}
								$this.feedback.message = r.data;
								$this.feedback.class = r.success ? 'ok' : 'error';
								$.unblockUI();
							},
							error: function (r) {
								$this.feedback.message = 'Ocorreu um erro';
								$this.feedback.class = 'error';
								$.unblockUI();
							}
						});

					});
				});
			}
		}
	});
}
